import React from 'react';
import Title from "../../composants/Title/Title"

const Erreur404 = (props) => (
    <>
        <Title>Erreur 404 !</Title>
        <p>La page n'existe pas ! </p>
    </>
)

export default Erreur404